﻿module Client.ContractPage.ChangeOrders.Rows

open Elmish
open Feliz
open PortalLibs.Shared

type RowsState = { Expanded: int64 list }
type Msg = Expand of int64 | Collapse of int64
let init() = { Expanded = [] }, Cmd.none
let update msg state =
  match msg with
  | Expand id -> { state with Expanded = id :: state.Expanded }, Cmd.none
  | Collapse id -> { state with Expanded = state.Expanded |> List.filter (fun x -> x <> id) }, Cmd.none
  
let selectedRow = style.backgroundColor "rgb(235, 235, 235)"

